import { colorSystem } from '@luminovo/design-system';

export const CMDK_STYLES = `
[cmdk-dialog] {
    position: fixed;
    top: 10vh;
    left: 50%;
    transform: translateX(-50%);
    max-width: 640px;
    width: 90vw;
    min-height: min(60vh, 480px);
    max-height: 70vh;
    background: ${colorSystem.neutral.white};
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 16px 70px rgba(0, 0, 0, 0.2), 0 0 0 1px ${colorSystem.neutral[2]};
    z-index: 1300;
    display: flex;
    flex-direction: column;
}

[cmdk-root] {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
}

[cmdk-overlay] {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.3);
    z-index: 1299;
}

[cmdk-input] {
    width: 100%;
    padding: 18px 20px;
    border: none;
    border-bottom: 1px solid ${colorSystem.neutral[2]};
    outline: none;
    font-size: 16px;
    font-family: "Inter var", "Inter", system-ui, sans-serif;
    background: transparent;
    color: ${colorSystem.neutral[9]};
}

[cmdk-input]::placeholder {
    color: ${colorSystem.neutral[5]};
}

[cmdk-list] {
    flex: 1;
    max-height: 50vh;
    overflow: auto;
    padding: 8px;
}

[cmdk-item] {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 10px 12px;
    border-radius: 8px;
    cursor: pointer;
    user-select: none;
    transition: background 0.1s ease;
}

[cmdk-item][data-disabled="true"] {
    opacity: 0.5;
    cursor: not-allowed;
}

[cmdk-item][data-selected="true"],
[cmdk-root]:not(.keyboard-navigating) [cmdk-item]:not([data-disabled="true"]):hover {
    background: ${colorSystem.neutral[1]} !important;
}

[cmdk-item] .cmdk-icon-default { display: flex; }
[cmdk-item] .cmdk-icon-hover { display: none; }

[cmdk-item][data-selected="true"] .cmdk-icon-default,
[cmdk-root]:not(.keyboard-navigating) [cmdk-item]:not([data-disabled="true"]):hover .cmdk-icon-default {
    display: none;
}
[cmdk-item][data-selected="true"] .cmdk-icon-hover,
[cmdk-root]:not(.keyboard-navigating) [cmdk-item]:not([data-disabled="true"]):hover .cmdk-icon-hover {
    display: flex;
}

[cmdk-group-heading] {
    padding: 8px 12px 4px;
    font-size: 11px;
    font-weight: 600;
    color: ${colorSystem.neutral[6]};
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

[cmdk-empty] {
    padding: 28px;
    text-align: center;
    color: ${colorSystem.neutral[6]};
    font-size: 14px;
}

[cmdk-loading] {
    padding: 16px;
    display: flex;
    justify-content: center;
}

.cmdk-quick-look-container {
    display: flex;
    flex: 1;
    min-height: 0;
    overflow: hidden;
    position: relative;
}

.cmdk-quick-look-commands {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-width: 0;
}

.cmdk-quick-look-panel {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    border-left: 1px solid ${colorSystem.neutral[2]};
    background: ${colorSystem.neutral[0]};
    box-shadow: -4px 0 16px rgba(0, 0, 0, 0.08);
    z-index: 10;
}

.cmdk-quick-look-panel-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    border-bottom: 1px solid ${colorSystem.neutral[2]};
    background: ${colorSystem.neutral[0]};
}

.cmdk-quick-look-panel-content {
    flex: 1;
    overflow: auto;
    padding: 16px;
}

`;

export function injectCmdkStyles(): void {
    if (typeof document !== 'undefined') {
        const styleId = 'cmdk-luminovo-styles';
        if (!document.getElementById(styleId)) {
            const style = document.createElement('style');
            style.id = styleId;
            style.textContent = CMDK_STYLES;
            document.head.appendChild(style);
        }
    }
}
